import PlayerVehicleModel from './PlayerVehicleModel';

export default class PlayerSampleView {

    public name: string | undefined;
    public categoryName: string | undefined;
    public imageUrl: string | undefined;
    public vehicles: PlayerVehicleModel[] = [];

    constructor(data: { [key: string]: any }) {
        this.name = data['name'] || undefined;
        this.categoryName = data['categoryName'] || undefined;
        this.imageUrl = data['imageUrl'] || undefined;
        this.vehicles = data['vehicles'].map((vehicle: { [key: string]: any }) => new PlayerVehicleModel(vehicle));
    }
}